import React from 'react';
import styled from 'styled-components';

import { Command, tabActions } from '@store/slices';
import { Label } from '@common/Label';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useDispatch } from 'react-redux';
import { NodeField } from '@components/Flow/Nodes';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
`;

interface Props {
  command: Command;
  field: NodeField;
}

export const ToggleTranscription: React.FC<Props> = ({ command, field }) => {
  const dispatch = useDispatch();

  const { state } = command;
  const { id, label, description } = field;

  const value = state[id].value;

  const toggleEnabled = (newVal: string) => {
    dispatch(tabActions.setSaved(false));

    if (newVal === 'false') {
      dispatch(tabActions.removeEdgeByHandle({ node_id: command.node.id, handle: 'call.transcription' }));
      dispatch(tabActions.removeEdgeByHandle({ node_id: command.node.id, handle: 'call.transcription.output_data' }));
    }

    dispatch(
      tabActions.nodeInputUpdate({
        nodeId: command.node.id,
        fieldId: field.id,
        value: newVal,
        fieldName: 'value',
      })
    );
  };

  return (
    <Container>
      <Label title={label} tooltip={description} />
      <ToggleButtonGroup
        size='small'
        color='primary'
        value={value}
        exclusive
        onChange={(_, newVal) => newVal !== undefined && newVal !== null && toggleEnabled(newVal)}
        fullWidth
      >
        <ToggleButton size='small' value='true'>
          Enabled
        </ToggleButton>
        <ToggleButton size='small' value='false'>
          Disabled
        </ToggleButton>
      </ToggleButtonGroup>
    </Container>
  );
};
